module.exports = __webpack_public_path__ + "static/media/ic-contact-time.00a6ff0d.svg";